import { combineReducers } from 'redux';
import appState from './appState/appState';
import auth from './auth/auth';

export default combineReducers({
  appState,
  auth,
});
